import { useEffect, useState } from "react";
import { Safari } from "../../components/ui/Safari";
import { getProjectsForSection } from "@/data/projects";
import { SectionLayout } from "@/components/layout/SectionLayout";
import { motion } from "framer-motion";

export function ProjectCarouselSection() {
  const projects = getProjectsForSection("carousel");
  const [currentProjectIndex, setCurrentProjectIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentProjectIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [projects.length]);

  return (
    <SectionLayout className="hidden w-full max-w-full sm:block">
      <motion.div
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{
          duration: 0.8,
          ease: "easeOut",
          delay: 2.0,
        }}
        className="aspect-[1203/753] w-full"
      >
        <Safari project={projects[currentProjectIndex]} />
      </motion.div>
    </SectionLayout>
  );
}
